<template>
  <c-source-form
    :columns="columns"
    :data="data"
    @submit="handleUpdate"
  />
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class AftersalesEdit extends Vue {

  data = {}

  get columns() {
    return createColumns();
  }

  async mounted() {
    this.data = await this.$request.get(`/after_sales/${this.$route.params.id}`);
  }

  async handleUpdate(data) {
    const id = this.$route.params.id;
    await this.$request.put(`/after_sales/${id}`, data);
    this.$router.push({ name: 'after_sales.show', params: { id } });
  }
}
</script>
